import React, { useContext } from 'react';
import EmptyBackground from '../EmptyBackground';
import { getIsShortStatus } from '../../../DeviationViews/_helpers';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
export const StatusStageBackground = ({ deviation  })=>{
    const isMobile = useContext(MobileContext);
    const isShortStatus = getIsShortStatus(deviation);
    const { needsSubscription  } = useSubscriptionTier(deviation);
    return (!isMobile || isShortStatus) && !needsSubscription ? /*#__PURE__*/ React.createElement(EmptyBackground, null) : null;
};
StatusStageBackground.displayName = 'StatusStageBackground';
export default StatusStageBackground;
